export default "__VITE_ASSET__W7CTF8ER__"